import { toast } from "react-toastify";
import { axiosInstance } from "../../../Utils/AxiosInstance";

export const GetAllNotification = (data) => {
  return {
    type: "get_allNotification",
    payload: data,
    loader: false,
  };
};

export const GetAllPendingNotification = (data) => {
  return {
    type: "get_allPendingNotification",
    payload: data,
    loader: false,
  };
};

export function getallNotifications() {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get("Vouchers/GetAllNotifications");

      if (response?.data?.IsSuccess === true) {
        dispatch(GetAllNotification(response.data));
      } else {
        toast.error(response?.data?.Message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("getallNotifications error:", error);
    }
  };
}

export function getAllPendingNotifications() {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.get("Vouchers/PendingNotifications");

      if (response?.data?.IsSuccess === true) {
        dispatch(GetAllPendingNotification(response.data));
        // toast.info(response.data.Message || "Pending notifications fetched");
      } else {
        toast.error(response?.data?.Message || "Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("getAllPendingNotifications error:", error);
    }
  };
}
